module.exports = __webpack_public_path__ + "static/img/news1.5d20934.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/data/news1.jpg
// module id = zjW7
// module chunks = 49